import { useEffect, useState } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { supabase } from "../../lib/supabaseClient.ts";

const ProductsPage = ({ categories }) => {
  const location = useLocation();
  const navigate = useNavigate();
  const params = new URLSearchParams(location.search);

  const selectedCategory = params.get("category") || "";
  const selectedSubcategory = params.get("subcategory") || "";
  const [products, setProducts] = useState([]);
  const [loading, setLoading] = useState(true);
    const [isMobile, setIsMobile] = useState(false);

    useEffect(() => {
        const checkMobile = () => setIsMobile(window.innerWidth <= 768); // mobile breakpoint
        checkMobile(); // initial check
        window.addEventListener("resize", checkMobile); // update on resize
        return () => window.removeEventListener("resize", checkMobile);
    }, []);
  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  }, []);

  // Filter products by category and subcategory
  const filteredProducts = products.filter(product => {
    let productCategories = [];
    let productSubcategories = [];

    // Parse category
    try {
      productCategories = JSON.parse(product.category);
      if (!Array.isArray(productCategories)) productCategories = [productCategories];
    } catch {
      productCategories = [product.category];
    }

    // Parse subcategory
    try {
      productSubcategories = JSON.parse(product.subcategory);
      if (!Array.isArray(productSubcategories)) productSubcategories = [productSubcategories];
    } catch {
      productSubcategories = [product.subcategory];
    }

    // Normalize strings
    productCategories = productCategories.map(c => c?.trim().toLowerCase());
    productSubcategories = productSubcategories.map(s => s?.trim().toLowerCase());
    const selectedCat = selectedCategory.trim().toLowerCase();
    const selectedSub = selectedSubcategory?.trim().toLowerCase();

    if (!productCategories.includes(selectedCat)) return false;
    if (selectedSub && !productSubcategories.includes(selectedSub)) return false;

    return true;
  });

  const productCount = filteredProducts.length;

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "smooth" });
    const fetchProducts = async () => {
      let query = supabase.from("products").select(`
        id,
        name,
        image,
        category,
        subcategory,
        price_range,
        old_price,
        stock_status,
        promo,
        promo_percentage,
        promo_type
      `);

      const { data, error } = await query;
      
      if (error) {
        console.error("Error fetching products:", error);
      } else {
        setProducts(data || []);
      }
      setLoading(false);
    };

    fetchProducts();
  }, []);

  return (
    <div className="container py-5">
      {/* Retour Button */}
      <div className="mb-4">
        <button
          onClick={() => navigate(-1)}
          style={{
            padding: "8px 12px",
            borderRadius: "50%",
            backgroundColor: "#fce5ef",
            border: "none",
            cursor: "pointer",
            color: "#c71585",
            fontSize: "20px",
            lineHeight: "1",
            display: "inline-flex",
            alignItems: "center",
            justifyContent: "center",
            boxShadow: "0 2px 6px rgba(0,0,0,0.1)"
          }}
          aria-label="Retour"
          title="Retour"
        >
          ←
        </button>
      </div>

      {/* Category & Subcategory Title */}
      <h2 className="mb-2 text-center">
        {selectedCategory} {selectedSubcategory && `> ${selectedSubcategory}`}
      </h2>
      <p className="text-center">
        {productCount} produit{productCount > 1 ? "s" : ""}
      </p>

      <div className="row justify-content-center">
        {filteredProducts.length > 0 ? (
          filteredProducts.map(product => {
            return (

            <div
              key={product.id}
className="col-6 col-sm-6 col-md-4 col-lg-3 mb-4 d-flex justify-content-center"
            >
                            <Link to={`/shop-details/${product.id}`}>

              <div
                className="shop-item text-center"
                style={{
                  border: "1px solid #eee",
                  borderRadius: "8px",
                  padding: "10px",
                  maxWidth: "200px",
                  width: "100%",
                  position: "relative"
                }}
              >
                <Link to={`/shop-details/${product.id}`}>
                  <div style={{ position: "relative", display: "inline-block", width: "100%" }}>
                    <img
                      src={product.image}
                      alt={product.name}
                      style={{
                        width: "100%",
                        height: "150px",
                        objectFit: "contain",
                                  marginLeft: isMobile ? "90px" : "0", // push to right on mobile

                        borderRadius: "6px",
                        marginBottom: "10px",
                      }}
                    />
                    
                    {/* Stock Badge */}
                    <div
                      style={{
                        position: "absolute",
                        top: "10px",
                        left: "10px",
                        backgroundColor:
                          (product.stock_status || "en stock").toLowerCase() === "en stock"
                            ? "#28a745"
                            : "#dc3545",
                        color: "#fff",
                        padding: "4px 8px",
                        borderRadius: "12px",
                        fontSize: "12px",
                        fontWeight: "600",
                        zIndex: 0,
                      }}
                    >
                      {product.stock_status || "en stock"}
                    </div>

                    {/* Promo Badge */}
                  
                  </div>
                </Link>

                <h5 className="mt-2" style={{ fontSize: "0.95rem", marginBottom: "8px" }}>
                  {product.name}
                </h5>

                {/* Price Display */}
                {product.price_range != 0 && (
                  <div style={{ marginTop: "10px" }}>
                    {product.promo ? (
                      // PROMO ACTIVE - Show both old and new price
                      <div style={{ display: "flex", flexDirection: "column", alignItems: "center", gap: "4px" }}>
                        {/* Old Price - Strikethrough */}
                        {product.old_price && (
                          <div style={{ position: "relative", display: "inline-block" }}>
                            <span style={{ 
                              color: "#999", 
                              fontSize: "0.85rem",
                              fontWeight: "700"
                            }}>
                              {parseFloat(product.old_price).toLocaleString('fr-FR', {
                                minimumFractionDigits: 3,
                                maximumFractionDigits: 3
                              })} DT
                            </span>
                            {/* Strikethrough line */}
                            <div style={{
                              position: "absolute",
                              top: "50%",
                              left: "-2px",
                              right: "-2px",
                              height: "1.5px",
                              background: "#ff4444",
                              transform: "translateY(-50%)"
                            }} />
                          </div>
                        )}

                        {/* New Promo Price */}
                        <div>
                          <span style={{ 
                            color: "#ff1493", 
                            fontWeight: "800",
                            fontSize: "0.95rem"
                          }}>
                            {(() => {
                              let finalPrice = parseFloat(product.price_range);
                              
                              // If percentage promo and old_price exists, calculate
                              if (product.promo_type === 'percentage' && product.promo_percentage && product.old_price) {
                                finalPrice = parseFloat(product.old_price) * (1 - product.promo_percentage / 100);
                              }
                              
                              return finalPrice.toLocaleString('fr-FR', {
                                minimumFractionDigits: 3,
                                maximumFractionDigits: 3
                              });
                            })()} DT
                          </span>
                        </div>

                        {/* Savings Amount */}
                        {product.old_price && (
                          <div style={{
                            fontSize: "0.7rem",
                            color: "#28a745",
                            fontWeight: "600",
                            backgroundColor: "#d4edda",
                            padding: "2px 8px",
                            borderRadius: "10px",
                            marginTop: "2px"
                          }}>
                            Économisez {(parseFloat(product.old_price) - parseFloat(product.price_range)).toLocaleString('fr-FR', {
                              minimumFractionDigits: 3,
                              maximumFractionDigits: 3
                            })} DT
                          </div>
                        )}
                      </div>
                    ) : (
                      // NO PROMO - Show regular price
                      <span style={{ 
                        color: "#ff1493", 
                        fontWeight: "bold",
                        fontSize: "1rem"
                      }}>
                        {parseFloat(product.price_range).toLocaleString('fr-FR', {
                          minimumFractionDigits: 3,
                          maximumFractionDigits: 3
                        })} DT
                      </span>
                    )}
                  </div>
                )}
              </div>
            </Link>
            </div>
       );
})
        ) : (
          <p className="text-center">Aucun produit trouvé.</p>
        )}
      </div>
    </div>
  );
};

export default ProductsPage;

